import { LoginRedirectPath } from '../resources/searchUtills'
export const envExternalConfigs = {
  local: {
    auth: {
      loginRedirect: `${window.location.origin}/auth/login`,
      authorizationUrl:
        'https://oauth.iam.perf.partnersonline.com/auth/oauth/v2/tgt/authorize/nla/1',
      logoutUrl: `https://oauth.iam.perf.partnersonline.com/login/responses/logoff.html`,
    },
    analytics: {
      url: 'https://stage-api.target.com/firefly_internal_events/v1/external',
    },
    graphql: {
      // url: 'http://localhost:9001/graphql', //for testing locally
      url: 'https://launchpadgraphql.dev.target.com/graphql',
    },
    bulk: {
      url: 'https://itembulkapi.dev.target.com/item_bulk/v2/',
    },
    validation: {
      url: 'https://itemvalidationsapi.dev.target.com/item_validation/v1/',
    },
  },
  dev: {
    auth: {
      authorizationUrl:
        'https://oauth.iam.perf.partnersonline.com/auth/oauth/v2/tgt/authorize/nla/1',
      logoutUrl: `https://oauth.iam.perf.partnersonline.com/login/responses/logoff.html`,
      loginRedirect: LoginRedirectPath(),
    },
    analytics: {
      url: 'https://stage-api.target.com/firefly_internal_events/v1/external',
    },
    graphql: {
      url: 'https://stage-api.target.com/graphql_launchpad/v1',
    },
    bulk: {
      url: 'https://stage-api.target.com/item_bulk/v2/',
    },
    validation: {
      url: 'https://itemvalidationsapi.dev.target.com/item_validation/v1/',
    },
  },
  stg: {
    auth: {
      authorizationUrl:
        'https://oauth.iam.perf.partnersonline.com/auth/oauth/v2/tgt/authorize/nla/1',
      logoutUrl: `https://oauth.iam.perf.partnersonline.com/login/responses/logoff.html`,
      loginRedirect: LoginRedirectPath(),
    },
    analytics: {
      url: 'https://stage-api.target.com/firefly_internal_events/v1/external',
    },
    graphql: {
      url: 'https://stage-api.target.com/graphql_launchpad/v1',
    },
    bulk: {
      url: 'https://stage-api.target.com/item_bulk/v2/',
    },
    validation: {
      url: 'https://stage-api.target.com/item_validation/v1/',
    },
  },
  prod: {
    auth: {
      authorizationUrl:
        'https://oauth.iam.partnersonline.com/auth/oauth/v2/tgt/authorize/nla/1',
      logoutUrl: `https://oauth.iam.partnersonline.com/login/responses/logoff.html`,
      loginRedirect: LoginRedirectPath(),
    },
    analytics: {
      url: 'https://api.target.com/firefly_internal_events/v1/external',
    },
    graphql: {
      url: 'https://api.target.com/graphql_launchpad/v1',
    },
    bulk: {
      url: 'https://api.target.com/item_bulk/v2/',
    },
    validation: {
      url: 'https://api.target.com/item_validation/v1/',
    }, // Todo before prod release
  },
}
